export default __webpack_public_path__ + "static/media/map-marker-car.9270babd.svg";